import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../utils/api';
import './AdminLogin.css';

const AdminResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/admin-reset-password', { token, password });
      setMsg('Password updated! Redirecting to sign in…');
      setTimeout(() => navigate('/ft-portal/login'), 2000);
    } catch (err) {
      setError(err.message || 'Failed to reset password. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="al-page">
      <div className="al-topbar">
        <div className="al-topbar-inner">
          <span>🇬🇧 DVSA Approved Driving School</span>
          <span>admin.fasttrackds.co.uk</span>
        </div>
      </div>
      <div className="al-body" style={{ justifyContent: 'center' }}>
        <div className="al-card" style={{ maxWidth: 420 }}>
          <div className="al-card-accent" />
          <h1 className="al-card-title">Reset Password</h1>
          <p className="al-card-sub">Enter your new admin password below</p>

          {msg ? (
            <div style={{ padding: '1rem', background: '#dcfce7', borderRadius: 8, color: '#166534', textAlign: 'center', fontWeight: 600 }}>{msg}</div>
          ) : !token ? (
            <div className="al-error">⚠️ Invalid or missing reset token. Please request a new password reset link.</div>
          ) : (
            <form onSubmit={handleSubmit} className="al-form">
              {error && <div className="al-error">⚠️ {error}</div>}
              <div className="al-field">
                <label htmlFor="new-pw">New Password</label>
                <input
                  type="password"
                  id="new-pw"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(''); }}
                  placeholder="Minimum 8 characters"
                  required
                  minLength={8}
                  autoFocus
                />
              </div>
              <div className="al-field">
                <label htmlFor="confirm-pw">Confirm New Password</label>
                <input
                  type="password"
                  id="confirm-pw"
                  value={confirm}
                  onChange={e => { setConfirm(e.target.value); setError(''); }}
                  placeholder="Re-enter your new password"
                  required
                />
              </div>
              <button type="submit" className="al-submit" disabled={loading}>
                {loading ? <><span className="al-spinner" /> Updating…</> : 'Update Password →'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminResetPassword;
